const primaryApiUrl = (process.env.REACT_APP_STRAPI_BASE_URL || 'https://contentcms.mof.gov.tl/api').replace(/\/$/, '');
const primaryUploadsUrl = (process.env.REACT_APP_STRAPI_UPLOADS_URL || primaryApiUrl.replace(/\/api$/, '')).replace(/\/$/, '');
const localUrl = 'http://localhost:1337';

/**
 * The localhost fallback only helps a developer running the website on their own machine.
 * On the public site it can never help a visitor, and browsers ask visitors for "local network
 * access" permission when a public page contacts localhost, so it is not attempted there.
 */
export function allowsLocalFallback(hostname = window.location.hostname) {
    return ['localhost', '127.0.0.1', '[::1]'].includes(hostname) ||
        process.env.REACT_APP_ALLOW_LOCAL_STRAPI === 'true';
}

let backend = { apiUrl: primaryApiUrl, uploadsUrl: primaryUploadsUrl };
let selection;

// Strapi's public health endpoint returns 204 without requiring an API token.
async function isAvailable(origin) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 4000);
    try {
        const response = await fetch(`${origin}/_health`, {
            signal: controller.signal,
            cache: 'no-store',
            credentials: 'omit'
        });
        return response.status === 204;
    } catch {
        return false;
    } finally {
        clearTimeout(timeout);
    }
}

// Share one check across all callers; reload the page to check the primary again.
export function initializeStrapiBackend() {
    if (!selection) {
        selection = (async () => {
            const primaryOrigin = primaryApiUrl.replace(/\/api$/, '');
            if (allowsLocalFallback() && primaryOrigin !== localUrl &&
                !await isAvailable(primaryOrigin) && await isAvailable(localUrl)) {
                backend = { apiUrl: `${localUrl}/api`, uploadsUrl: localUrl };
            }
            return backend;
        })();
    }
    return selection;
}

export const getStrapiBackend = () => backend;
